export const hubspotHowToActionTextParser = action => {
  return action.query;
};